// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"7891e990","349":"fbb016f4","420":"9a9dfa93","809":"c76729d2","845":"67712ac7","932":"55fe1d9d"}[chunkId] + ".chunk.js";
};